// Public LiveView bundle - JavaScript for public pages that use LiveView
// This bundle includes LiveView, minimal hooks, and essentials for public LiveView pages

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "phoenix_html";

// Establish Phoenix Socket and LiveView configuration.
import { Socket } from "phoenix";
import { LiveSocket } from "phoenix_live_view";
import topbar from "../vendor/topbar";

// Alpine.js for interactivity (without persist plugin for public pages)
import Alpine from 'alpinejs'
window.Alpine = Alpine
Alpine.start()

// Import only the hooks needed for public pages
import ClearFlashHook from "./hooks/clear-flash-hook";
import ColorSchemeHook from "./hooks/color-scheme-hook";
import PlausibleHook from "./hooks/plausible-hook";
import PasskeySignIn from "./hooks/passkey-sign-in-hook";

// Minimal hooks configuration for public LiveView pages
const hooks = {
  ClearFlashHook,
  ColorSchemeHook,
  PlausibleHook,
  PasskeySignIn,
};

// Plausible Analytics integration (for form tracking on contact/newsletter pages)
import PlausibleAnalytics from "./lib/plausible-analytics";

// Initialize Plausible auto-tracking
document.addEventListener("DOMContentLoaded", () => {
  PlausibleAnalytics.initAutoTracking();
});

// Make PlausibleAnalytics globally available
window.PlausibleAnalytics = PlausibleAnalytics;

// LiveSocket configuration
let csrfToken = document
  .querySelector("meta[name='csrf-token']")
  .getAttribute("content");

let liveSocket = new LiveSocket("/live", Socket, {
  hooks: hooks,
  dom: {
    onBeforeElUpdated(from, to) {
      if (from._x_dataStack) {
        window.Alpine.clone(from, to);
      }
    },
    // This allows you to auto focus with <input autofocus />
    onNodeAdded(node) {
      if (node instanceof HTMLElement && node.autofocus) {
        node.focus();
      }
    },
  },
  params: { _csrf_token: csrfToken },
});

// Show progress bar on live navigation and form submits
topbar.config({ barColors: { 0: "#29d" }, shadowColor: "rgba(0, 0, 0, .3)" });
window.addEventListener("phx:page-loading-start", (_info) => topbar.show(300));
window.addEventListener("phx:page-loading-stop", (_info) => topbar.hide());

// connect if there are any LiveViews on the page
liveSocket.connect();

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket;